import React from 'react'; 
import {getData } from '../../../core/HttpAction';  
import Table from '../../../core/Table'; 
import {PdfGenrate} from '../../../core/Pdf'; 

const Url='/library/student-most-taken-report';
const CustomButton=({props})=>{   
    return<button style={{float:'left'}} type="button" onClick={()=>props.download()}   className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Download</button>;
};

const CustomAction=({props})=>{    
    return <select className="md-input" onChange={(e)=>props.custonAction(e)} style={{width:'125px',float: 'left', marginRight:'8px'}} > 
        <option value="staff">Staff</option>  
        <option value="student">Student</option> 
    </select>;
}; 

const columns=[
  
    {
        key:'name',
        displayName:'Student Name'
    },
    {
        key:'id_no',
        displayName:'ISBN No'
    },  
    {
        key:'count',
        displayName:'Total Books Taken'
    }  
];
 
class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                type: 'student'   
            }, 
            data:[],
            preloader:true
        }; 
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData=()=>{
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch=(params)=>{
        this.setState({params:{...this.state.params,...params},preloader:true},()=>{
            this.fetchData();
        });
    }
 
    download=()=>{
        const pdfArray=[
            {
                index:'table-view',
                data:document.getElementById('pdfContentData'),
            }
        ]; 
        PdfGenrate({pdfArray,filename:'student-most-read-report'}); 
    }
    custonAction=(e)=> {
        const type=e.target.value?e.target.value:'';
        this.setState({params:{...this.state.params,type},preloader:true},()=>{
            this.fetchData();
        }); 
    }
    render() {
        let {preloader,data}=this.state;
        return ( 
            <div> 
                <Table
                    data={data}
                    handleFetch={this.handleFetch}
                    preloader={preloader}
                    permission="top-reader-report"
                    title="Top Reader Report"
                    columns={columns}
                    primaryKey="student_id" 
                    download={this.download}
                    custonAction={this.custonAction}
                    CustomFilter={ CustomAction }
                    CustomButton={CustomButton}
                /> 

                <div style={{display:'none'}}>
                                        
                                            
                    <table id={'pdfContentData'} >
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Student Name</th>  
                                <th>ID No</th>
                                <th>Total Books Taken</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 
                                data.data && data.data.map((val,k)=>{ 
                                    return( 
                                        <tr key={k}>
                                            <td>{parseInt(k)+1} </td>
                                            <td>{val.name}</td>
                                            <td>{val.id_no}</td>
                                            <td>{val.count}</td>
                                        </tr> 
                                    );
                                })
                            }
                        </tbody> 
                    </table> 
                </div>
            </div>
        );
    }
}
export default Reports;


// WEBPACK FOOTER //
// ./src/components/Reports/LibraryReport/topStudentReadBookReport.js